"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _lodash = require("lodash");

var _default = function _default(analytics) {
  var appState = {
    search: {
      searchTerm: "",
      identifiedRanges: []
    },
    timeline: {
      points: {
        usedBy: "PointTrack"
      },
      intervals: {
        usedBy: "BoxTrack"
      },
      channels: {
        usedBy: "BarAxis"
      }
    },
    view: {
      activeTab: 1
    },
    classifiers: [],
    bookmarks: {
      markers: []
    },
    parsedFromAnalytics: {
      activeGroup: 0,
      activeSpeaker: 0,
      activeTopic: 0,
      metadata: {},
      topics: [],
      keyWords: [],
      groups: [],
      metrics: [],
      metricGroups: [],
      speakers: [],
      transcript: [],
      fullTurns: [],
      transcriptSpeakers: [],
      classifiers: [],
      detectors: [],
      mediaId: "",
      categories: [],
      verbs: [],
      speakerSentiments: [],
      interactionType: "unknown",
      entities: []
    },
    unused: {
      analyticsLoaded: false,
      metadata: [],
      topicsIds: [],
      activeTopic: "",
      groupsIds: [],
      activeGroup: "",
      activeSpeaker: "",
      jobTasks: [],
      mediaUrlLoaded: false
    },
    player: {
      skipPrevNextHit: false,
      mediaElement: {},
      mediaUrl: "",
      currentTime: 0,
      duration: 0,
      paused: false,
      volume: 0.5,
      playbackRate: 1,
      type: "",
      isSentimentAnalyzerOn: false,
      isKeywordAnalyzerOn: false,
      isPhraseSupportingAnalyzerOn: false,
      isVerbNounAnalyzerOn: false
    }
  };

  if (analytics) {
    // Apply parsed analytics to appState state :
    var keysToReplace = Object.keys(appState.parsedFromAnalytics);
    var filteredAnalyticsProps = (0, _lodash.pick)(analytics, keysToReplace);
    Object.assign(appState.parsedFromAnalytics, filteredAnalyticsProps);
  }

  return appState;
};

exports["default"] = _default;